import el from '@finn-no/create-element';

// TODO: this is pretty much a subset of favorites.toggle.controller, they should merge
export default {
    dependencies: ['$element', 'favoritesservice'],
    callable(formEle, favoritesService) {
        const nameInputEle = formEle.elements.name;
        const submitEle = formEle.elements.submit;
        const errorMessageEle = el('p.mhn.cherry', {
            id: 'new-list-error-message',
        });

        formEle.addEventListener('submit', createList);
        nameInputEle.addEventListener('input', removeErrorMessage);

        function createItemElement(folderId, folderName) {
            return el(
                'li.list-line.t4',
                null,
                el(
                    'a.stone.pvm.blockify.truncate',
                    { href: favoritesService.getFavoriteListUrl(folderId) },
                    folderName
                )
            );
        }

        function addErrorMessage(message) {
            nameInputEle.setAttribute('aria-invalid', true);
            nameInputEle.setAttribute('aria-describedby', errorMessageEle.id);
            errorMessageEle.textContent = message;
            formEle.after(errorMessageEle);
        }

        function removeErrorMessage() {
            nameInputEle.removeAttribute('aria-invalid');
            nameInputEle.removeAttribute('aria-describedby');
            errorMessageEle.remove();
        }

        function createList(event) {
            event.preventDefault();

            const folderName = nameInputEle.value;
            if (folderName.trim() === '') {
                return;
            }

            submitEle.classList.add('inprogress');
            nameInputEle.disabled = true;

            favoritesService
                .createList(folderName)
                .then(folderId => {
                    const favList = document.querySelector(
                        '[data-favorite-list]'
                    );
                    const ele = createItemElement(folderId, folderName);
                    favList.appendChild(ele);
                    submitEle.focus();
                })
                .catch(message => {
                    addErrorMessage(message);
                    nameInputEle.disabled = false;
                    nameInputEle.focus();
                })
                .then(() => {
                    nameInputEle.disabled = false;
                    submitEle.classList.remove('inprogress');
                });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/favoritesCreateList.js